/**
 * Configuration générale du traducteur IA.
 * Centralise toutes les constantes métier et paramètres applicatifs.
 */
const translatorConfig = {

    /**
     * Saisie texte
     */
    input: {
        /** Nombre maximum de caractères autorisés dans la zone de saisie. */
        maxLength: 500,
        messages: {
            noModelAlertTitle: 'Aucun modèle disponible',
            noModelAlertBody: 'Aucun modèle de traduction n\'est configuré pour le moment. Veuillez réessayer plus tard.',
            translateButton: 'Traduire',
            translateButtonLoading: 'Traduction en cours…',
            translateFileButton: 'Traduire et télécharger',
            translateFileButtonLoading: 'Traduction en cours…'
        }
    },

    /**
     * Saisie fichier Excel
     */
    fileInput: {
        /** Extensions de fichiers acceptées. */
        allowedExtensions: ['.xls', '.xlsx'],
        /** Valeur de l'attribut accept pour l'input file. */
        accept: '.xls,.xlsx,.XLS,.XLSX',
        /** Taille maximale autorisée en octets (1 Mo). */
        maxSizeBytes: 1024 * 1024,
        /** Messages affichés dans le composant. */
        messages: {
            placeholder: 'Sélectionner un fichier',
            browseButtonLabel: 'Parcourir',
            infoTitle: 'Format attendu',
            infoBody: 'Le document téléchargé doit inclure une liste de concepts, chaque concept étant inscrit sur une ligne distincte du fichier fourni. La taille ne doit pas dépasser 1 Mo.',
            errorInvalidExtension: (ext) => `Format de fichier non supporté (${ext}). Veuillez sélectionner un fichier .xls ou .xlsx.`,
            errorFileTooLarge: (maxMo) => `Le fichier dépasse la taille de (${maxMo} Mo) autorisée.`,
            errorEmptyFile: 'Le fichier ne contient aucune ligne valide.',
            errorReadFailure: 'Impossible de lire le fichier. Vérifiez qu\'il s\'agit bien d\'un fichier .xls ou .xlsx valide.'
        },
        /**
         * Colonnes de sortie disponibles pour la traduction par lot.
         * Chaque entrée : { key, id, label, defaultValue }
         */
        outputColumns: [
            { key: 'scoreConfiance', id: 'col-score', label: 'Score de confiance', defaultValue: false },
            { key: 'synonymes', id: 'col-synonymes', label: 'Synonymes', defaultValue: false },
            { key: 'termesProches', id: 'col-termes-proches', label: 'Termes proches', defaultValue: false },
            { key: 'sources', id: 'col-sources', label: 'Sources', defaultValue: false },
            { key: 'themes', id: 'col-themes', label: 'Concept parent', defaultValue: false },
        ]
    },

    /**
     * Messages d'erreur du store (appels API)
     */
    store: {
        messages: {
            errorFeedback: 'Erreur lors de l\'envoi du feedback. Veuillez réessayer.',
            errorTranslationFile: 'Erreur lors de la traduction du fichier. Veuillez réessayer.',
            errorTranslation: 'Erreur lors de la traduction. Veuillez réessayer.',
            errorLoadModels: 'Impossible de charger les modèles de traduction.'
        }
    },

    /**
     * Affichage du résultat de traduction (TranslatorDisplayOutput)
     */
    displayOutput: {
        messages: {
            labelDefault: 'Texte traduit',
            loading: 'Traduction en cours…',
            ariaLabel: 'Résultat de la traduction',
            placeholder: "Le résultat de la traduction s'affichera ici.",
            copyButton: 'Copier le texte traduit',
            copiedButton: 'Copié !'
        }
    },

    /**
     * Panneau de résultat complet (TranslatorOutput)
     */
    output: {
        messages: {
            panelHeader: 'Résultat de la traduction',
            thumbUpValidated: 'Traduction validée',
            thumbUpDefault: 'La traduction est correcte',
            thumbDownTitle: 'Proposer une traduction alternative',
            filtersTitle: 'Filtres',
            filterSynonymes: 'Synonymes',
            filterTermesProches: 'Termes proches',
            filterTerminologie: 'Terminologie :',
            filterResetTitle: 'Tout désélectionner',
            filterResetLabel: 'Réinitialiser',
            noResultsDetails: 'Aucun résultat pour la terminologie sélectionnée.',
            accordionDetails: 'Détails',
            accordionOtherTranslations: "Voir d'autres traductions",
            copyAltTitle: 'Copier ce terme',
            copiedAltTitle: 'Copié !',
            copiedConfirmation: 'Copié !',
            noOtherTranslations: 'Aucune traduction pour la terminologie sélectionnée.',
            modalTitle: 'Proposer une traduction',
            modalCloseLabel: 'Fermer',
            modalSourceLabel: 'Contenu source',
            modalTranslatedLabel: 'Texte traduit',
            modalPropositionLabel: 'Votre proposition de traduction',
            modalPropositionPlaceholder: 'Saisissez votre traduction proposée…',
            modalFieldRequired: 'Ce champ est obligatoire.',
            modalCommentLabel: 'Commentaire',
            modalCommentPlaceholder: 'Expliquez la raison de votre proposition (source, contexte clinique, etc.)…',
            modalSuccessMessage: 'Votre proposition a bien été envoyée. Merci !',
            modalCancelLabel: 'Annuler',
            modalSubmitLabel: 'Envoyer ma proposition'
        }
    }

}

export default translatorConfig
